// Navigate from a globally-mounted dialog while dashboard dialogs are open.
//
// Dashboard dialogs (screenshot viewer, gallery, events, ...) register a
// router guard through mobileBackButtonMixin that turns ANY navigation into
// "close me" + next(false) — one dialog per attempt, so the mobile back
// button closes them one at a time. A navigation started from a dialog that
// is NOT part of that stack (the NC1 unlock dialog lives in App.vue) is
// therefore swallowed: the underlying dialog closes and the user stays on
// the dashboard, which looked like a dead link (finding N16 was the same
// mechanism on the dashboard's own prompts; 2026-09-11 the unlock dialog's
// "Account page" link).
//
// Retry: each attempt peels one dialog (its v-if destroys it and unregisters
// the guard on the next tick); give up after `maxTries`. A `duplicated`
// failure means we are already there.

import { nextTick } from 'vue'
import { isNavigationFailure, NavigationFailureType } from 'vue-router'

export async function dialogSafeNavigate (router, to, maxTries = 6) {
  for (let i = 0; i < maxTries; i++) {
    let failure
    try {
      failure = await router.push(to)
    } catch (e) {
      failure = e
    }
    if (!failure) return true
    if (isNavigationFailure(failure, NavigationFailureType.duplicated)) return true
    await nextTick()
    await new Promise((resolve) => setTimeout(resolve, 60))
  }
  return false
}
